import { UniButton } from '@/design-system/components/buttons';
import { UniIconButton } from '@/design-system/components/buttons';
import { Divider } from '@/design-system/components/Divider';
import { BottomSheetHeader } from '@/design-system/components/headers';
import { Icon } from '@/design-system/components/icons/Icon';
import { ModalHeader } from '@/design-system/components/modal';
import { TextBody, TextTitle } from '@/design-system/components/typography';
import { pointer } from 'd3';
import { SxProp, View, Image, useDripsyTheme, styled } from 'dripsy';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Row } from '@/design-system/components/layout';
import { LinearGradient } from 'expo-linear-gradient';

export interface ReplaceCardProps {
  onClose: () => void;
  onStep: (step: string) => void;
}

export const ReplaceCardNativeOneScreen: React.FC<ReplaceCardProps> = (props) => {
  const { onClose, onStep } = props;
  const { t } = useTranslation('account-management');
  const { topHeader, body, textMb, itemStyle, flexContainer, address, modal } = sxStyles;

  const Gradient = styled(LinearGradient, {})({});
  const { theme } = useDripsyTheme();

  return (
    <View>
      <Gradient colors={['rgba(49, 75, 108, 0.8)', 'rgba(39, 70, 115, 0.8)', '#3C6291', '#1E304B']}>
        <Row sx={{ justifyContent: 'space-between', alignItems: 'center', px: '$4', mt: '$5', mb: '$4' }}>
          <UniIconButton
            icon="arrowLeft"
            options={{ iconStyles: { color: theme?.colors?.$white as string } }}
            onPress={() => onStep('zero')}></UniIconButton>
          <View sx={{ textAlign: 'center', width: '100%' }}>
            <TextTitle bold sx={{ color: theme?.colors?.$white as string }}>
              Replace Card
            </TextTitle>
          </View>
        </Row>
      </Gradient>
      <View sx={modal}>
        <View sx={body}>
          <TextBody sx={textMb} semiBold>
            Select a reason to replace the card.
          </TextBody>
          <View sx={{ gap: 10 }}>
            <TextBody sx={itemStyle} onPress={() => onStep('two')}>
              <TextBody semiBold>Self Pickup</TextBody>
              <Icon name="arrowRightOrangeCircle" />
            </TextBody>
            <TextBody sx={itemStyle} onPress={() => onStep('two')}>
              <View sx={flexContainer}>
                <TextBody semiBold>Mail to Address</TextBody>
                <TextBody sx={address}>
                  Block 1, 1/F, Flat A, Super Building,
                  <br />1 Sample Road, Jordan, Hong Kong
                </TextBody>
              </View>
              <Icon name="arrowRightOrangeCircle" />
            </TextBody>
          </View>
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  modal: {
    px: '$4',
    py: '$5'
  },
  topHeader: {
    height: 70,
    justifyContent: 'center'
  },
  body: {},
  textMb: {
    marginBottom: 20
  },
  itemStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: 20,
    py: 30,
    cursor: 'pointer',
    shadowOpacity: 0.1,
    shadowOffset: {
      width: 2,
      height: 2
    },
    shadowRadius: 10,
    borderRadius: 10
  },
  title: {
    color: '$textSecondary',
    fontSize: 12
  },
  flexContainer: {
    gap: 4
  },
  address: {
    color: '$textSecondary',
    fontSize: 13
  }
};
